import NZCommonAdminNav from "./Common/NZCommonAdminNav";

const NZAdminNavBar = ({ active, handleOnCLickDropDownMenu }) => {
  return <NZCommonAdminNav active={active} handleOnCLickDropDownMenu={handleOnCLickDropDownMenu}></NZCommonAdminNav>;
};

export default NZAdminNavBar;
